export class PackagingCodeBe {
    PkgCodeId: number;
    PkgCode: string = "";
    MHNo: string;
    MHDescription: string;
    CodeIdPicture: number;
    PictureId: number;
    PkgCodeDesc: string;
    PkgLength: number;
    PkgWidth: number;
    PkgHeight: number;
    PkgCodeWeight: number;
    PackagingMaterialLength: number;
    PackagingMaterialWidth: number;
    PackagingMaterialHeight: number;
    PackagingMaterialWeight: number;
    CodeCompositionId: number;
    CodeCompositionMHId: number;
    Level: number;
    CompositionQty: number;
    HasConstraint: boolean;
}

export class PackagingCodeListBe {
    PkgCodeId: number;
    PkgCode: string;
    PkgCodeDesc: string;
    HasConstraint: boolean;
    StatusId: number;
}

export class ConstraintListBE {
    Id: number;
    PackagingCode: string;
    Description: string;
    ConstraintCode: string;
    QuantityOfLevel: number;
    ConstraintId: number;
}

export class PkgCodeBE {
    Id: number = -1;
    PackagingCode: string = "";
    Description: string = "";
    Length: number = 0;
    Width: number = 0;
    Height: number = 0;
    Weight: number = 0;
    Pictures: Array<PictureBE> = [];
    Constraints: Array<PkgCodeConstraintBE> = [];
    Compositions: Array<PkgCodeCompositionBE> = [];
    StatusId: number;
    UserId:string="";
      //new field stacking limit on top value set to 10000 as default 
      StackingLimit:number ;
      // stackability field for dropdown
     Stackability:string ="Can both be on top or below another packaging"
}

export class PictureBE {
    Id: number;
    Label: string;
    PictureName: string;
    PictureImage: Uint8Array[];
}

export class PkgCodeConstraintBE {
    CodeConstraintId: number = 0;
    CodeId: number = 0;
    Code: string = "";
    Description: string = "1";
    Quantity: number = 1;
    ConstraintPkgCodeWeight: number = 0;
}

export class PkgCodeCompositionBE {
    CodeCompositionId: number = 0;
    MaterialId: number = 0;
    MHNO: string = "";
    Description: string = "";
    Level: number = 1;
    Quantity: number = 1;
    MaterialUnitWeight: number = 0;
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-code/shared/packaging-code.model.ts